<script setup>
import {onMounted, ref} from "vue";
import {useCallsStore} from "@/stores/callsStore";

const callsStore = useCallsStore();

const currTab = ref('call');

onMounted(() => {
  callsStore.fetchHistory()
});


function colorRowItem({item}) {
  if (callsStore.selectedCall[0] === item) {
    return {class: 'selected'};
  }
  if (item.type === "Emergency") {
    return {class: 'row-emergency row'};
  }
  return {class: 'row'};
}


const headersCall = [
  // {title: 'Operator ID', key: 'operatorId', headerProps: {style: 'font-weight: bold'}, value: item => item.direction === 'Incoming' ? item.caller : item.callee},
  {title: 'Train Num / HH Name', key: 'trainNum', headerProps: {style: 'font-weight: bold'}, value: item => item.trainNum},
  // {title: 'Callee', key: 'callee', headerProps: {style: 'font-weight: bold'}, value: item => item.callee},
  // {title: 'Run & Drv Nr.', key: 'runAndDriveNum', headerProps: {style: 'font-weight: bold'}},
  {title: 'Zone', key: 'zoneId', headerProps: {style: 'font-weight: bold'}, sortable: false},
  {title: 'Direction', key: 'direction', headerProps: {style: 'font-weight: bold'}},
  {title: 'Status', key: 'status', headerProps: {style: 'font-weight: bold'}},
  {title: 'Time', key: 'time', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => new Date(item.time).toLocaleDateString() + " " + new Date(item.time).toLocaleTimeString()},
  {title: 'Type', key: 'type', sortable: true, headerProps: {style: 'font-weight: bold'}},
  {title: 'Volume', key: 'volume', sortable: true, headerProps: {style: 'font-weight: bold'}},
]

const headersHistCall = [
  // {title: 'Operator ID', key: 'operatorId', headerProps: {style: 'font-weight: bold'}, value: item => item.direction === 'Incoming' ? item.caller : item.callee},
  {title: 'Train Num / HH Name', key: 'trainNum', headerProps: {style: 'font-weight: bold'}, value: item => item.trainNumber},
  // {title: 'Callee', key: 'callee', headerProps: {style: 'font-weight: bold'}, value: item => item.callee},
  {title: 'Direction', key: 'direction', headerProps: {style: 'font-weight: bold'}},
  // {title: 'Run & Drv Nr.', key: 'runAndDriveNum', headerProps: {style: 'font-weight: bold'}},
  {title: 'Status', key: 'status', headerProps: {style: 'font-weight: bold'}},
  {title: 'Start Time', key: 'startTime', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => new Date(item.startTime).toLocaleDateString() + " " + new Date(item.startTime).toLocaleTimeString()},
  {title: 'End Time', key: 'endTime', sortable: true, headerProps: {style: 'font-weight: bold'}, value: item => new Date(item.endTime).toLocaleDateString() + " " + new Date(item.endTime).toLocaleTimeString()},
  {title: 'Type', key: 'type', sortable: true, headerProps: {style: 'font-weight: bold'}},
]

// Handle row selection
function handleRowSelection(_, {internalItem}) {
  // toggle selection
  if (callsStore.selectedCall[0] === internalItem.value) {
    //callsStore.selectedCall = [];
    callsStore.setSelectedCall();
  } else {
    callsStore.setSelectedCall(internalItem.value);
  }
}

</script>

<template>
  <v-card class="h-50" style="height: 100px;">
    <v-tabs
        v-model="currTab"
        bg-color="grey"
        class="border-t"
        height="30px"
    >
      <v-tab value="call">Individual Call</v-tab>
      <v-tab value="callHistory">Historic Individual Call</v-tab>
    </v-tabs>
    <v-card-text class="pa-0 h-100">
      <v-tabs-window v-model="currTab" style="height: 100%;">
        <v-tabs-window-item style="height: 100%;" value="call">
          <div style="height: calc(100% - 30px); overflow-y: auto;">
            <v-data-table
                v-model="callsStore.selectedCall"
                :headers="headersCall"
                :items="callsStore.activeCalls"
                :items-per-page="-1"
                :row-props="colorRowItem"
                clickable-rows
                density="compact"
                fixed-header
                hide-default-footer
                item-value="item.item"
                return-object
                select-strategy="single"
                style="height: 100%;"
                @click:row="handleRowSelection"
            >
            </v-data-table>
          </div>
        </v-tabs-window-item>

        <v-tabs-window-item style="height: 100%;" value="callHistory">
          <div style="height: calc(100% - 30px); overflow-y: auto;">

            <v-data-table
                :headers="headersHistCall"
                :items="callsStore.callHistory"
                :items-per-page="-1"
                density="compact"
                fixed-header
                hide-default-footer
                select-strategy="single"
                style="height: 100%;"
            >
            </v-data-table>
          </div>
        </v-tabs-window-item>

      </v-tabs-window>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-card {
  border-radius: 0%;
}

:deep(.row-emergency) {
  background-color: #EE5A5AFF;
  color: white;
}

:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.row-emergency:hover) {
  background-color: #933030;
  color: white;
}

:deep(.selected) {
  background-color: #3f3f3f;
  color: white;
}
</style>
